import React from "react";

import { useState, useEffect } from "react";
import MockPagination from "./Pagination";
import MockNavigation from "./MockNavigation";
import KeyBoardCheckPage from "./KeyboardCheckPage";
import HeadphoneCheckPage from "./HeadphonePage";
import MicrophoneCheckPage from "./MicrophonePage";
import TestIntroductionPage from "./TestIntroduction";
import SpeakingInstructionPage from "./SpeakingInstruction";
import FullSectionPage from "./FullSectionTable";
import SectionPage from "./SectionPage";
import PersonalIntroductionPage from "./PersonalIntroductionPage";
import ReadAloudPage from "./Speaking/ReadAloudPage";
import RepeatSentencePage from "./Speaking/RepeatSentencePage";
import DescribeImageMockPage from "./Speaking/DescribeImageMock";
import ReTellMockPage from "./Speaking/ReTellMock";
import ShortAnswersMockPage from "./Speaking/ShortAnswersMock";
import SummarizeMockPage from "./Writing/SummarizeMock";
import WriteEssayMockPage from "./Writing/WriteEssay";
import MultipleTypeSingleMockPage from "./Reading/MultipleTypeSingleMock";
import MultipleTypeDoubleMockPage from "./Reading/MultipleDoubleTypleMock";
import ReArrangeSentenceMockPage from "./Reading/ReArrangeMock";
import ReadingFillInTheBlanksMockPage from "./Reading/ReadingFillInTheBlanksMock";
import FillInTheBlanksReadingAndWritingMockPage from "./Reading/FillInTheBlanksReadingAndWritingMock";
import SummarizeSpokenTestMockPage from "./Listening/SummarizeSpokenTextMock";
import MCQSingleAnswerMockPage from "./Listening/MCQSingleAnswerMock";
import MCQMultipleAnswerMockPage from "./Listening/MCQMultipleAnswerMock";
import FillInTheBlanksMockPage from "./Listening/FillInTheBlanksMock";
import HighlightCorrectSummaryMockPage from "./Listening/HighlightCorrectSummaryMock";
import SelectMissingWordsMockPage from "./Listening/SelectMissingWordMock";
import HighlightIncorrectWordMockPage from "./Listening/HighlightIncorrectWordMock";
import WriteFromDictationMockPage from "./Listening/WriteFromDictationMock";
import Notification from "../QuestionPage/Notification";
import ConfirmDialog from "./PopUp";
import Loading from "./SpinnerLoading"; // Import the loading component
import Timer from "./Timer";
import ListeningSectionTable from "./ListeningSectionTable";

// function ConfirmDialog({ message, onConfirm, onCancel }) {
//   return (
//     <div
//       style={{
//         position: "fixed",
//         top: "50%",
//         left: "50%",
//         transform: "translate(-50%, -50%)",
//         backgroundColor: "white",
//         border: "1px solid #ccc",
//         padding: "20px",
//         zIndex: 1000,
//       }}
//     >
//       <p>{message}</p>
//       <button onClick={onConfirm}>Yes</button>
//       <button onClick={onCancel}>No</button>
//     </div>
//   );
// }

// Page Html
export default function ListeningMockTestPage() {
  const [MockData, setMockData] = useState({
    data: [],
  });
  const [userInputs, setUserInputs] = useState({});

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationType, setNotificationType] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [nextPage, setNextPage] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // New state for loading

  useEffect(() => {
    const fetchMockData = async () => {
      try {
        const response = await fetch("/api/listeningmockquestions/all", {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();

          setMockData({
            data: data,
          });

          console.log("Data:", data);
        } else {
          console.error(
            "Failed to fetch MockTest data. Status:",
            response.status
          );
        }
      } catch (error) {
        console.error("Error fetching MockTest data:", error);
      } finally {
        setLoading(false); // Set loading to false regardless of success or failure
      }
    };

    fetchMockData();
  }, []);

  console.log("Mock Data:", MockData.data.AnswershortQuestion);

  const handleInputChange = (questionType, questionIndex, answer) => {
    setUserInputs((prevInputs) => ({
      ...prevInputs,
      [questionType]: {
        ...prevInputs[questionType],
        [questionIndex]: answer,
      },
    }));
  };

  console.log("User Input", userInputs);

  const splitData = (data, size) => {
    const chunks = [];
    for (let i = 0; i < data.length; i += size) {
      chunks.push(data.slice(i, i + size));
    }
    return chunks;
  };

  const handleSubmit = async () => {
    const payload = { userInputs, MockData }; // Assuming userInputs and MockData are defined
    const payloadString = JSON.stringify(payload);
    const maxChunkSize = 50000; // Reduce the chunk size further (e.g., 50KB)
    const chunks = splitData(payloadString, maxChunkSize);

    console.log(`Total chunks: ${chunks.length}`);

    try {
      for (const [index, chunk] of chunks.entries()) {
        console.log(`Sending chunk ${index + 1} of ${chunks.length}`);
        const response = await fetch("/api/save-listeningmocktestdata", {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ chunk, index, totalChunks: chunks.length }),
        });
        if (!response.ok) {
          console.error("Failed to submit data chunk. Status:", response.status);
          throw new Error(`Failed to submit data chunk. Status: ${response.status}`);
        }
      }
      console.log("Data submitted successfully");
      setMessage("Mock data saved successfully!");
      setNotificationType("success");
      setShowNotification(true); // Show notification

      setTimeout(() => {
        setLoading(false);
        setSubmitted(true);
      }, 2000);
    } catch (error) {
      console.error("Error submitting data:", error);
      setMessage("Failed to save MockTest.");
      setNotificationType("error");
      setShowNotification(true); // Show error notification
      setLoading(false);
      setSubmitted(false);
    }
  };

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  // Empty dependency array to fetch data only once on mount
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = 22;
  const handleNext = () => {
    setShowConfirmDialog(true);
    setNextPage((prevPage) => prevPage + 1);
  };

  const handleConfirm = () => {
    setShowConfirmDialog(false);
    setIsLoading(true); // Start loading

    // Set timeout to simulate loading delay
    setTimeout(() => {
      setIsLoading(false); // End loading
      setCurrentPage(nextPage); // Proceed to the next page
    }, 100);
  };

  const handleCancel = () => {
    setShowConfirmDialog(false); // Hide the confirmation dialog
  };

  const handlePrevious = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const disableNext = currentPage === totalPages;
  const disablePrevious = currentPage === 1;

  const renderPage = () => {
  // SummarizeSpokenText → Q1 (Page 5)

    if (currentPage >= 5 && currentPage <= 5) {
      const questionIndex = currentPage - 5;
      const currentQuestion = MockData.data.SummarizeSpokenText[questionIndex];
      return (
        <SummarizeSpokenTestMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("SummarizeSpokenText", questionIndex, answer)
          }
          questionNumber={questionIndex + 1}
          maxQuestion={18}
        />
      );
    }

      // McqSingleAnswer → Q2–3 (Pages 6–7)

    if (currentPage >= 6 && currentPage <= 7) {
      const questionIndex = currentPage - 6;
      const currentQuestion = MockData.data.McqSingleAnswer[questionIndex];
      return (
        <MCQSingleAnswerMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("McqSingleAnswer", questionIndex, answer)
          }
          questionNumber={questionIndex + 2} // Q2–3
          maxQuestion={18}
        />
      );
    }
      // McqDoubleAnswer → Q4–5 (Pages 8–9)

    if (currentPage >= 8 && currentPage <= 9) {
      const questionIndex = currentPage - 8;
      const currentQuestion = MockData.data.McqDoubleAnswer[questionIndex];
      return (
        <MCQMultipleAnswerMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("McqDoubleAnswer", questionIndex, answer)
          }
          questionNumber={questionIndex + 4} // Q4–5
          maxQuestion={18}
        />
      );
    }
      // FillBlank → Q6–7 (Pages 10–11)

      if (currentPage >= 10 && currentPage <= 11) {
        const questionIndex = currentPage - 10;
      const currentQuestion = MockData.data.FillBlank[questionIndex];
      return (
        <FillInTheBlanksMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("FillBlank", questionIndex, answer)
          }
          questionNumber={questionIndex + 6} // Q6–7
          maxQuestion={18}
        />
      );
    }
      // HighlightSummary → Q8–10 (Pages 12–14)

      if (currentPage >= 12 && currentPage <= 14) {
        const questionIndex = currentPage - 12;
      const currentQuestion = MockData.data.HighlightSummary[questionIndex];
      return (
        <HighlightCorrectSummaryMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("HighlightSummary", questionIndex, answer)
          }
          questionNumber={questionIndex + 8} // Q8–10
          maxQuestion={18}
        />
      );
    }
      // MissingWord → Q11–12 (Pages 15–16)

      if (currentPage >= 15 && currentPage <= 16) {
      const questionIndex = currentPage - 15;
      const currentQuestion = MockData.data.MissingWord[questionIndex];
      return (
        <SelectMissingWordsMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("MissingWord", questionIndex, answer)
          }
          questionNumber={questionIndex + 11} // Q11–12
          maxQuestion={18}
        />
      );
    }
      // IncorrectWord → Q13–14 (Pages 17–18)

      if (currentPage >= 17 && currentPage <= 18) {
        const questionIndex = currentPage - 17;
      const currentQuestion = MockData.data.IncorrectWord[questionIndex];
      return (
        <HighlightIncorrectWordMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("IncorrectWord", questionIndex, answer)
          }
          questionNumber={questionIndex + 13} // Q13–14
          maxQuestion={18}
        />
      );
    }
    
    // WritefromDictation → Q15–18 (Pages 19–22)

    if (currentPage >= 19 && currentPage <= 22) {
      const questionIndex = currentPage - 19;
      const currentQuestion = MockData.data.WritefromDictation[questionIndex];
      return (
        <WriteFromDictationMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("WritefromDictation", questionIndex, answer)
          }
          questionNumber={questionIndex + 15} // Q15–18
          maxQuestion={18}
        />
      );
    }

    switch (currentPage) {
      case 1:
        return <HeadphoneCheckPage />;
      case 2:
        return <MicrophoneCheckPage />;
      case 3:
        return <KeyBoardCheckPage />;
      case 4:
        return <ListeningSectionTable />;

      // case 26:
      //   return <WriteFromDictationMockPage />;

      default:
        return null;
    }
  };

  return (
    <div>
      {renderPage()}
      {isLoading && <Loading />}
      {showConfirmDialog && (
        <ConfirmDialog
          message="Proceed to the next question?"
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}
      <div className="absolute top-16 font-bold p-2 pt-4 ml-[1255px] ">
        {" "}
        {currentPage >= 9 && (
          <Timer initialMinutes={33} initialSeconds={0} Text="Time Remaining" />
        )}
      </div>

      <MockNavigation
        onNext={handleNext}
        onPrevious={handlePrevious}
        disableNext={disableNext}
        disablePrevious={disablePrevious}
        currentPage={currentPage} // Pass currentPage here
        totalPages={totalPages} // Pass totalPages here
        handleSubmit={handleSubmit} // Pass handleSubmit here
      />

      {showNotification && (
        <Notification
          message={message}
          type={notificationType}
          onClose={handleCloseNotification}
        />
      )}
    </div>
  );
}
